import dic from '@/assets/dictionary/index.js'
import { LANG } from '@/libs/constants'

const { howItWorks } = dic[LANG]

export const newExplonations = (howItWorks) => {
  return [
    {
      id: 1,
      label: howItWorks.list[1].label,
      description: howItWorks.list[1].description,
      imgUrl: `1_${LANG}.webp`,
      imgClassicUrl: `1_${LANG}.jpg`,
    },
    {
      id: 2,
      label: howItWorks.list[2].label,
      description: howItWorks.list[2].description,
      imgUrl: `2_${LANG}.webp`,
      imgClassicUrl: `2_${LANG}.jpg`,
    },
    {
      id: 3,
      label: howItWorks.list[3].label,
      description: howItWorks.list[3].description,
      imgUrl: `3_${LANG}.webp`,
      imgClassicUrl: `3_${LANG}.jpg`,
    },
    {
      id: 4,
      label: howItWorks.list[4].label,
      description: howItWorks.list[4].description,
      imgUrl: `4_${LANG}.webp`,
      imgClassicUrl: `4_${LANG}.jpg`,
    },
  ]
}

export default {
  namespaced: true,
  state: {
    explonations: newExplonations(howItWorks),
  },
}
